import ApolloRootProvider from './ApolloRootProvider';

export default ApolloRootProvider;
